import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const THEMES = {
  dark: {
    name: 'dark',
    label: 'Тёмная',
    background: '#0b0e11',
    card: '#1e2329',
    border: '#2b3139',
    text: '#eaecef',
    textSecondary: '#848e9c',
    primary: '#f0b90b',
    success: '#0ecb81',
    danger: '#f6465d',
    warning: '#f0b90b',
    info: '#1e90ff',
  },
  light: {
    name: 'light',
    label: 'Светлая',
    background: '#fafafa',
    card: '#ffffff',
    border: '#e5e7eb',
    text: '#1f2937',
    textSecondary: '#6b7280',
    primary: '#f0b90b',
    success: '#10b981',
    danger: '#ef4444',
    warning: '#f59e0b',
    info: '#3b82f6',
  },
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    const saved = localStorage.getItem('exdex_theme');
    return saved || 'dark';
  });

  useEffect(() => {
    localStorage.setItem('exdex_theme', theme);
    const themeColors = THEMES[theme];
    
    // Apply theme to body
    document.body.style.backgroundColor = themeColors.background;
    document.body.style.color = themeColors.text;
    
    // Apply CSS custom properties for components that use COLORS directly
    const root = document.documentElement;
    root.style.setProperty('--color-background', themeColors.background);
    root.style.setProperty('--color-card', themeColors.card);
    root.style.setProperty('--color-border', themeColors.border);
    root.style.setProperty('--color-text', themeColors.text);
    root.style.setProperty('--color-text-secondary', themeColors.textSecondary);
    root.style.setProperty('--color-primary', themeColors.primary);
    root.style.setProperty('--color-success', themeColors.success);
    root.style.setProperty('--color-danger', themeColors.danger);
    root.style.setProperty('--color-warning', themeColors.warning);
    root.style.setProperty('--color-info', themeColors.info);
    
    // Update scrollbar colors
    const style = document.createElement('style');
    style.id = 'theme-scrollbar';
    const existingStyle = document.getElementById('theme-scrollbar');
    if (existingStyle) existingStyle.remove();
    
    style.textContent = `
      ::-webkit-scrollbar-track { background: ${themeColors.card}; }
      ::-webkit-scrollbar-thumb { background: ${themeColors.border}; }
      ::-webkit-scrollbar-thumb:hover { background: ${themeColors.primary}; }
    `;
    document.head.appendChild(style);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => prev === 'dark' ? 'light' : 'dark');
  };

  const colors = THEMES[theme];

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggleTheme, colors, THEMES }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export default ThemeContext;
